import { siteNav } from '@/mocks/home';
import useToast from '@/hooks/useToast';
import Toast from '@/components/base/Toast';

export default function SiteNav() {
  const { message, show } = useToast();

  return (
    <section id="sites" className="bg-background-50 border-t border-foreground-950/10 scroll-mt-16">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <p className="text-xs tracking-[0.25em] text-primary-600 font-label">DIRECTORY · 站点导航</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              可直接播放的高清站点
            </h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-xl">
              每个站点都标注了当前状态与最近一次巡检时间，点状态为「在线」的入口即可打开观看。
            </p>
          </div>
          <span className="text-xs text-foreground-500 font-label whitespace-nowrap">共 6 个精选入口</span>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {siteNav.map((site) => (
            <article
              key={site.id}
              className="group flex flex-col rounded-lg border border-foreground-950/12 bg-background-100/60 p-4 md:p-5 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950">{site.name}</h3>
                {site.status === 'online' ? (
                  <span className="inline-flex items-center gap-1.5 text-[11px] text-secondary-900 bg-secondary-100 border border-secondary-200 rounded-full px-2 py-0.5 whitespace-nowrap">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
                    在线
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1.5 text-[11px] text-foreground-500 bg-background-200 rounded-full px-2 py-0.5 whitespace-nowrap">
                    <span className="w-1.5 h-1.5 rounded-full bg-foreground-400" />
                    线路维护
                  </span>
                )}
              </div>

              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{site.desc}</p>

              <div className="mt-4 flex items-center justify-between border-t border-foreground-950/10 pt-3">
                <span className="text-[11px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 border border-accent-200">
                  {site.tag}
                </span>
                <button
                  type="button"
                  onClick={() => show(`演示入口：正在打开「${site.name}」，本站仅做导航展示`)}
                  className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
                >
                  进入观看
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </button>
              </div>
              <p className="mt-2 text-[11px] text-foreground-400 font-label">最近巡检：{site.updated}</p>
            </article>
          ))}
        </div>
      </div>
      <Toast message={message} />
    </section>
  );
}